import { useNavigate } from 'react-router-dom';
import { BiomarkerCard } from '@/app/components/labs/components/biomarker-card/biomarker-card';
import { ROUTE_LABS } from '@/constants/routes';

interface BiomarkerSummaryCardProps {
  optimalCount: number;
  normalCount: number;
  outOfRangeCount: number;
}

export function BiomarkerSummaryCard({ optimalCount, normalCount, outOfRangeCount }: BiomarkerSummaryCardProps) {
  const navigate = useNavigate();

  const handleViewResults = () => {
    navigate(ROUTE_LABS);
  };

  return (
    <div className="rounded-[10px] bg-[#F7F9FB] p-6">
      {/* Header */}
      <div className="mb-4">
        <h2 className="mb-2 text-[18px] leading-tight font-bold text-gray-900">Your Catch Labs</h2>
        <p className="text-sm leading-relaxed text-gray-600">
          These results show how your body is performing today. Most biomarkers are in the optimal or healthy range, a
          few may need attention. Tracking these markers over time helps you take control and lower your risk.
        </p>
      </div>

      {/* Biomarker Cards Grid */}
      <div className="mb-6 flex justify-center gap-2 md:grid md:grid-cols-3 md:gap-4">
        <div className="shrink-0 md:w-auto">
          <BiomarkerCard
            count={optimalCount}
            label="Optimal"
            color="bg-catch-avocado-400"
            totalDots={50}
            variant="light"
          />
        </div>
        <div className="shrink-0 md:w-auto">
          <BiomarkerCard
            count={normalCount}
            label="Normal"
            color="bg-catch-light-blue"
            totalDots={50}
            variant="light"
          />
        </div>
        <div className="shrink-0 md:w-auto">
          <BiomarkerCard
            count={outOfRangeCount}
            label="Out of Range"
            color="bg-catch-salmon"
            totalDots={50}
            variant="light"
          />
        </div>
      </div>

      {/* View Results Button */}
      <button
        onClick={handleViewResults}
        className="w-full rounded-full bg-[#183344] px-6 py-3 text-sm font-bold text-white transition-all hover:bg-[#1a3d4f]"
      >
        View Your Results
      </button>
    </div>
  );
}
